import {Controller} from "@hotwired/stimulus";
import {waitForOutletToBeLoaded} from "../js/functions";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        litigantId: Number,
        litigantName: String,
        source: String,
        flowFromEmail: Boolean,
    };

    static outlets = [
        'video-consultation-modal',
    ];

    async videoConsultationModalOutletConnected() {
        if (this.flowFromEmailValue) {
            dataLayer.push({
                "event": "dataLayer.gaEvent",
                "gaEvent": {
                    "category": "Flow",
                    "action": "Flow from email",
                    "label": "video consultation",
                },
            });

            await waitForOutletToBeLoaded(() => this.videoConsultationModalOutlet);

            this.openModal();
        }
    }

    openModal() {
        this.videoConsultationModalOutlet.litigantIdValue = this.litigantIdValue;
        this.videoConsultationModalOutlet.litigantNameValue = this.litigantNameValue;
        this.videoConsultationModalOutlet.sourceValue = this.sourceValue;
        this.videoConsultationModalOutlet.open();
    }
}
